import { Helmet } from "react-helmet-async";
import SuggestedBrands from "src/sections/overview/dashboards/views/brand-pulse/suggestedBrands";

export default function LeaderboardCompetitorsSelection() {
    return (
        <>
            <Helmet>
                <title>Competitors Selection</title>
            </Helmet>

            <SuggestedBrands />
        </>
    );
}
